var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXtal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 22.9091C5 23.5116 5.44772 24 6 24H18C18.5523 24 19 23.5116 19 22.9091V6.11515C19 5.6844 18.8831 5.26329 18.6641 4.90489L16.3359 2.73147C16.1169 2.37307 16 1.95196 16 1.52122V0H8V1.52122C8 1.95196 7.88312 2.37307 7.6641 2.73147L5.3359 4.90489C5.11688 5.26329 5 5.6844 5 6.11515V22.9091ZM8.42899 10.7427L11.1954 7.30435L13.3715 9.85618L12.3888 14.8021H11.1851L10.9244 12.7132L12.4913 9.79776L11.3112 8.3098L11.8915 9.73737L10.6271 11.8286L9.00922 11.2353L10.373 12.7032L10.3826 14.8021H9.17885L8.42899 10.7427ZM13.657 13.9766C13.6935 14.0799 13.5925 14.8021 13.5925 14.8021H12.79L13.1358 12.8676C13.1358 12.8676 13.6308 13.8733 13.657 13.9766ZM14.1827 10.9958L15.5577 12.9926L14.7962 14.8021H13.9938L14.1381 14.3668L15.0475 13.2423L13.9573 13.9002C13.8315 13.5375 13.7336 13.3121 13.6402 13.0972C13.5523 12.895 13.4685 12.702 13.3693 12.4124L14.1827 10.9958ZM15.2937 15.2207H8.73204L8.7266 15.2213C7.71704 15.7078 7.78327 17.2073 8.77761 17.7327H15.278C16.2049 17.2644 16.2703 15.825 15.2937 15.2207ZM9.56278 18.3633L9.98132 19.826H11.9875L12.2166 18.3671L11.5811 18.3593L11.2863 19.6449L10.8549 18.3682L9.56278 18.3633ZM12.79 19.8261L12.2851 19.2308C12.3078 19.0828 12.3633 18.9228 12.4213 18.7558C12.4656 18.6286 12.5112 18.4972 12.5447 18.364H13.598L13.6254 19.0324L13.8481 18.3593L14.3231 18.3632L13.9938 19.8261H12.79Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H4V1H1V23H4V24H0V0Z",
    fill: "#474747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23H23V1H20V0H24V24H20V23Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtal);
export default __webpack_public_path__ + "static/media/xtal.e6f28d2de18c837c216a662c51beeef7.svg";
export { ForwardRef as ReactComponent };